import {
  deleteDataTraining,
  fetchDataTraining,
  patchDataTraining,
  postDataTraining,
} from "../services/training";

const handleFetchTrainings = async () => {
  const uri = `api/trainings`;
  const response = fetchDataTraining({ uri });
  return response;
};

const handleFetchUpcomingTrainings = async () => {
  const uri = `api/trainings/upcomming`;
  const response = fetchDataTraining({ uri });
  return response;
};

const handleFetchTraining = async ({ _id }: any) => {
  const uri = `api/trainings/${_id}`;
  const response = fetchDataTraining({ uri });
  return response;
};

const handleCreateTraining = async (data: any) => {
  const uri = `api/trainings`;
  const response = postDataTraining({ data, uri });
  return response;
};

const handleUpdateTraining = async ({ data, _id }: any) => {
  const uri = `api/trainings/${_id}`;
  const response = patchDataTraining({ data, uri });
  return response;
};

const handleDeleteTraining = async ({ _id }: any) => {
  const uri = `api/trainings/${_id}`;
  const response = deleteDataTraining({ uri });
  return response;
};

const handleAssignTrainingCourse = async ({ data, _id }: any) => {
  const uri = `api/trainings/${_id}/course`;
  const response = postDataTraining({ data, uri });
  return response;
};

const handleAssignAttendee = async ({ data, _id }: any) => {
  const uri = `api/trainings/${_id}/enroll`;
  const response = patchDataTraining({ data, uri });
  return response;
};


const handleRescheduleTraining = async ({ data, training_id }: any) => {
  const uri = `api/trainings/${training_id}/reschedule`;
  const response = patchDataTraining({ data, uri });
  return response;
};

const handleRemoveAttendee = async ({ _id, user_id }: any) => {
  const uri = `api/trainings/${_id}/participants/${user_id}`;
  const response = deleteDataTraining({ uri });
  return response;
};

const handleAssignTrainingOrganizer = async ({ data, _id }: any) => {
  const uri = `api/trainings/${_id}/organizer`;
  const response = patchDataTraining({ data, uri });
  return response;
};

const handleCreateAttendance = async ({ data, training_id }: any) => {
  const uri = `api/trainings/${training_id}/attendance`;
  const response = patchDataTraining({ data, uri });
  return response;
};

export {
  handleFetchTrainings,
  handleFetchTraining,
  handleCreateTraining,
  handleUpdateTraining,
  handleDeleteTraining,
  handleAssignTrainingCourse,
  handleAssignAttendee,
  handleCreateAttendance,
  handleRescheduleTraining,
  handleAssignTrainingOrganizer,
  handleFetchUpcomingTrainings,
  handleRemoveAttendee,
};
